import React, { useEffect, useState } from "react";
// import cookie from "js-cookie";
import {getUserSelector, userSelector, useUserStore } from "store/userInfo.store";
import Loading from "components/Loading";
export const CoreContext = React.createContext({
  core: {},
  setCore: () => {},
});

export const CoreProvider = ({ children }) => {
  // const localUser = cookie.get("user");

  
  const [menu, setMenu] = useState();
  const currentUser = useUserStore(userSelector);
  const getCurrentUser = useUserStore(getUserSelector);
  // const userInitialState = {
  //   ...(localUser ? JSON.parse(localUser) : {}),
  //   ...{ isLoggedIn: cookie.get("token") != null },
  // };
  const [core, setCore] = useState({ user: currentUser });
  const value = {
    core,
    setCore,
    menu,
    setMenu,
  };
  useEffect(() => {
    if (currentUser?.userNotLoaded) {
      // console.log("cookies",document.cookie)
      getCurrentUser();
    }

    // return () => {
    //   clearUserStore();
    // };
  }, [getCurrentUser, currentUser.userNotLoaded]);

  return (
    <CoreContext.Provider value={value}>
      {/* <code>{JSON.stringify(currentUser, null, 2)}</code>
      <code>{JSON.stringify(userNotLoaded, null, 2)}</code> */}
      {currentUser?.userNotLoaded ? <Loading /> : <>{children}</>}
    </CoreContext.Provider>
  );
};
